import { Eyebrow, Reveal } from "./Reveal";

const POINTS = [
  ["01", "Three balls", "Game, Splatter and Fluorescent."],
  ["02", "Fair prices", "Quality balls priced for everyday play."],
  ["03", "Australia-wide", "Posted to your door, wherever you ride."],
];

export const Story = () => (
  <section id="story" data-testid="story-section" className="grain relative overflow-hidden bg-[#112E23]">
    <img src="/images/pow-family.jpg" alt="Family polocrosse chukka riding in at a country carnival" className="story-bg-photo absolute inset-0 h-full w-full object-cover object-[center_40%]" />
    <div className="absolute inset-0 bg-[#0B1D16]/75" />
    <div className="relative mx-auto max-w-[1400px] px-5 py-24 text-[#F5F0E8] sm:px-8 lg:py-36">
      <div className="max-w-3xl">
        <Reveal>
          <Eyebrow light>Our story</Eyebrow>
          <h2 className="font-display text-6xl font-black uppercase leading-[0.88] tracking-tight sm:text-7xl">
            Born in Australia. <span className="font-serif-i normal-case font-normal text-[#D99B26]">Played everywhere.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} className="mt-8 space-y-5 text-base leading-relaxed text-[#F5F0E8]/90 sm:text-lg">
          <p>POW Polocrosse Ball began as a small Western Australian family business with a simple goal: create a quality, reliable and affordable ball for every day play.</p>
          <p>Seven years of development, extensive testing and careful refinement shaped the finished ball. Our commitment to quality is clear in every ball made.</p>
        </Reveal>
      </div>
      <div className="mt-14 divide-y divide-[#F5F0E8]/25 border-y border-[#F5F0E8]/25">
        {POINTS.map(([n, t, d], i) => (
          <Reveal key={n} delay={0.1 + i * 0.08} y={20} className="group flex items-baseline gap-6 py-5">
            <span className="font-mono text-xs text-[#D99B26]">{n}</span>
            <span className="font-display text-2xl font-extrabold uppercase transition-transform duration-500 group-hover:translate-x-2 sm:text-3xl">{t}</span>
            <span className="ml-auto hidden text-right text-sm text-[#F5F0E8]/80 sm:block">{d}</span>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
